import { Typography } from 'antd';
import React from 'react';

import User from 'types/models/user';

function ContactSummary({ contact }: { contact: Partial<User> | undefined }) {
  return (
    <Typography>
      {contact?.firstName}
      {contact?.lastName ? ` ${contact?.lastName}` : ''}
      {typeof contact?.mobileNumberFormatted === 'string' && (
        <>
          <br />
          <Typography.Text>{contact.mobileNumberFormatted}</Typography.Text>
        </>
      )}
      {typeof contact?.landlineNumberFormatted === 'string' && (
        <>
          <br />
          <Typography.Text>{contact.landlineNumberFormatted}</Typography.Text>
        </>
      )}
      {typeof contact?.email === 'string' && (
        <>
          <br />
          <Typography.Text copyable>{contact.email}</Typography.Text>
        </>
      )}
    </Typography>
  );
}

export default ContactSummary;
